import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { X, AlertTriangle } from 'react-feather';
import { Modal } from 'react-bootstrap';

const FEEDBACK_URI = 'https://apitn.vietnewscorp.vn/feedback';

function ModalForm(props) {
  const [show, setShow] = useState(false);
  const { register, handleSubmit, reset, errors } = useForm();
  const { termId, isOpen } = props;

  useEffect(() => {
    if (isOpen === true) {
      setShow(true);
    } else {
      setShow(false);
    }
  });

  const handleClose = () => {
    setShow(false);
    props.setClose(false);
  };

  const onSubmit = (data, e) => {
    const { title, name, email, content } = data || {};
    // alert(JSON.stringify(data));
    e.target.reset();
    // POST request using fetch()
    fetch(FEEDBACK_URI, {
      // Adding method type
      method: 'POST',
      // Adding body or contents to send
      body: JSON.stringify({
        title,
        name,
        email,
        content,
        termId,
      }),

      // Adding headers to the request
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
      // Converting to JSON
      .then(response => {
        props.onModalSendRequest();
        // setModalSuccess(true);
      });
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <div className="modal-header text-center border-0 pb-0">
          <div className="w-100 pt-4">
            <h5 className="h3">Đóng góp ý kiến</h5>
          </div>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
            <span aria-hidden="true">
              <X />
            </span>
          </button>
        </div>
        <div className="modal-body px-md-4 px-lg-5 pb-4 pb-lg-5 pt-0">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group mt-4">
              <input type="text" name="title" className="form-control" placeholder="Tiêu đề" ref={register} />

              {errors.title && <div className="text-small text-danger mt-2">Bạn chưa ghi tiêu đề </div>}
            </div>

            <div className="form-group mt-4">
              <textarea
                id="contact-message"
                name="content"
                rows={4}
                placeholder="Ý kiến của bạn"
                className="form-control"
                defaultValue=""
                ref={register({ required: true, minLength: 20 })}
              />
              {errors.content ? (
                <div className="text-small text-danger mt-2">Nội dung cần lớn hơn 20 kí tự </div>
              ) : (
                <small>Nội dung cần lớn hơn 20 kí tự</small>
              )}
            </div>

            <div className="form-row mt-4">
              <div className="col-sm">
                <div className="form-group">
                  {/* <label htmlFor="contact-name">Tên của bạn</label> */}
                  <input type="text" name="name" placeholder="Tên của bạn" className="form-control " ref={register} />

                  {errors.name && <div className="text-small text-danger mt-2">Bạn chưa ghi tên </div>}
                </div>
              </div>
              <div className="col-sm">
                <div className="form-group">
                  <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    className="form-control"
                    ref={register({ required: true })}
                  />
                </div>
              </div>
            </div>

            <div className="mt-3 text-center">
              <button className="btn btn-primary btn-lg btn-block" type="submit">
                Gửi ý kiến
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
}

function ModalSuccess(props) {
  const [show, setShow] = useState(false);

  const isOpen = props.isOpen;

  useEffect(() => {
    if (isOpen === true) {
      setShow(true);
    } else {
      setShow(false);
    }
  });

  const handleClose = () => {
    setShow(false);
    props.setClose(false);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <div className="modal-header border-0 pb-0">
          <div className="w-100 pt-4">
            <div className="text-center">
              <img src="/static/img/email-success.svg" alt="Feedback Success" className="img-fluid" width="80" />
            </div>
          </div>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
            <span aria-hidden="true">
              <X />
            </span>
          </button>
        </div>
        <div className="modal-body px-md-4 px-lg-5 pb-4 pb-lg-5 text-center">
          <h5 className="h3">Cám ơn bạn</h5>
          {/* eslint-disable-next-line max-len */}
          <div>Những ý kiến của bạn sẽ góp phần giúp chúng tôi tạo ra Website tốt hơn để phục vụ mọi người</div>
        </div>
      </Modal>
    </>
  );
}

function FeedBack(props) {
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalForm, setmodalForm] = useState(false);
  const { termId } = props;

  const handleModalForm = () => {
    setmodalForm(true);
  };

  const handleModalSendRequest = () => {
    setmodalForm(false);
    setModalSuccess(true);
  };

  return (
    <>
      <div className="card card-warning mt-5 mb-5">
        <div className="card-body ">
          <AlertTriangle /> Nếu nội dung không đúng hoặc chưa đầy đủ, chúng tôi rất mong nhận được ý kiến đóng góp từ
          các bạn bằng cách{' '}
          <span className="link font-weight-bold" onClick={handleModalForm}>
            Nhấn vào đây
          </span>
        </div>
      </div>

      <ModalSuccess isOpen={modalSuccess} setClose={i => setModalSuccess(i)} />
      <ModalForm
        termId={termId}
        isOpen={modalForm}
        setClose={i => setmodalForm(i)}
        onModalSendRequest={() => handleModalSendRequest()}
      />
    </>
  );
}

export default FeedBack;
